export default {
  "content": "<circle cx=\"18\" cy=\"18\" r=\"14\" fill=\"#C9CBD4\" stroke=\"#8A8F9E\" stroke-width=\"8\"/>",
  "attrs": {
    "width": "36",
    "height": "36",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};